<template>
	<h1>About</h1>
	<img src="@/assets/ranks/rank-adm5.png" alt="Fleet Admiral">
</template>

<script>
export default {
	name: 'About',
};
</script>

<style></style>
